module.exports = __webpack_public_path__ + "static/assets/93371402202f7e0843e75c3649cfcc93.svg";